export default "__VITE_ASSET__13690315__"